import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  TREQUEST_NPS_GET_FORM,
  TRESPONSE_NPS_GET_FORM,
  TRESPONSE_NPS_SUBMIT_FORM,
  TREQUEST_NPS_SUBMIT_FORM,
} from '@monorepo/types';
import { NpsEnvService } from './nps-env.service';
@Injectable({
  providedIn: 'root',
})
export class NpsDataService {
  constructor(public http: HttpClient, private npsEnvService: NpsEnvService) {}

  getNpsForm(request: TREQUEST_NPS_GET_FORM) {
    const url = this.npsEnvService.getUrlFromEnv('GET_NPS_FEEDBACK_FORM');
    return this.http.post<TRESPONSE_NPS_GET_FORM>(url, request);
  }

  submitNpsFeedback(request: TREQUEST_NPS_SUBMIT_FORM) {
    const url = this.npsEnvService.getUrlFromEnv('SUBMIT_NPS_FEEDBACK');
    return this.http.post<TRESPONSE_NPS_SUBMIT_FORM>(url, request);
  }
}
